import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Image, Form, Button, DropdownButton } from 'react-bootstrap'
import EditText from './EditText'
import { DraftContext } from './ContextProvider'

function Records({ setting }) {
  const { closeRecord = () => {} } = setting
  const { saves, editSave, copySave, recoverSave } = useContext(DraftContext)
  // const [records, setRecords] = useState([
  //   {
  //     name: '7月21日 下午2:00',
  //   },
  //   {
  //     name: '7月20日 下午2:00',
  //   },
  // ])

  const handleInputChange = (id, e) => {
    editSave(id, {
      vtitle: e,
    })
  }

  return (
    <div className="rightSidenav">
      <div className="sidenav-header">
        <Image src="/images/svgicons/records.svg" alt="" />
        版本紀錄
        <Button className="btn-text close-btn" onClick={() => closeRecord()}>
          <div
            className="svgIcon"
            style={{
              maskImage: `url('/images/svgicons/close.svg')`,
            }}
          >
            關閉
          </div>
        </Button>
      </div>
      <div className="scroll-sidebar">
        {saves.map((record, index) => (
          <div
            className="record-item"
            key={`record${index}`}
            style={{ zIndex: saves.length - index }}
          >
            <strong>
              {moment(record.created_on).format('yyyy年M月DD日 下午HH:mm')}
            </strong>
            {record.setting.vtitle && <strong>{record.setting.vtitle}</strong>}
            {index === 0 ? '目前版本' : ''}

            <div className="project-setting">
              <DropdownButton
                title={
                  <div className="btn-setting d-flex">
                    <div
                      className="svgIcon settingIcon"
                      style={{
                        maskImage: `url('/images/svgicons/setting.svg')`,
                      }}
                    >
                      設定
                    </div>
                  </div>
                }
              >
                <div className="project-setting-card toggle-wrap shadow-block">
                  <Form>
                    <ul className="toggle-wrap-nav">
                      <li>
                        <EditText
                          setting={{
                            title: record.setting.name || '',
                            handleInputChange: (e) => {
                              handleInputChange(record.version_id, e)
                            },
                            style: 'front',
                            defauleTitle: '為此版本命名',
                          }}
                        />
                      </li>
                      <li>
                        <Button
                          className="btn-text"
                          onClick={() => {
                            copySave(record.version_id)
                          }}
                          // onClick={() => {
                          //   setRecords([
                          //     { name: `${record.name}的副本` },
                          //     ...records,
                          //   ])
                          // }}
                        >
                          <div
                            className="svgIcon"
                            style={{
                              maskImage: `url('/images/svgicons/copy.svg')`,
                            }}
                          >
                            建立副本
                          </div>
                          建立副本
                        </Button>
                      </li>
                      <li>
                        <Button
                          className="btn-text"
                          onClick={() => {
                            recoverSave(record.version_id)
                            // handleClose()
                          }}
                        >
                          <div
                            className="svgIcon"
                            style={{
                              maskImage: `url('/images/svgicons/preview.svg')`,
                            }}
                          >
                            還原此版本
                          </div>
                          還原此版本
                        </Button>
                      </li>
                    </ul>
                  </Form>
                </div>
              </DropdownButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

Records.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default Records
